import { CSSObject } from "@emotion/serialize";

export const AppContainerStyles: CSSObject = {
  maxWidth: "1200px",
  marginLeft: "auto",
  marginRight: "auto",
};
